export const TEXTS = {
  MODAL_TITLE: 'Реквизиты не совпадают',
  MODAL_DESCRIPTION: 'Реквизиты в личном кабинете не совпадают с реквизитами, указанными при подписании акцепта.',
  WARNING_TEXT:
    'Подписание акцепта от имени другого юридического лица или ИП запрещено.\nТекущий акцепт будет отменён.',
  AFTER_WARNING_TEXT: 'Проверьте данные и подпишите акцепт повторно с корректными реквизитами.',
  COMPANY_SECTION_TITLE: 'В личном кабинете',
  PAYER_SECTION_TITLE: 'В подписанном акцепте',
  INN_LABEL: 'ИНН:',
  NAME_LABEL: 'Наименование:',
  MODAL_BUTTON_TEXT: 'Хорошо',
};
